import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'

const ContentPersonal = () => {
    return (
        <>
            <Heading variant="100" as="h1">
                Guide to personal loans
            </Heading>
            <Heading variant="60" as="h2">
                What is a personal loan?
            </Heading>

            <Text>
                Personal loans are one of the most common types of loans,
                commonly taken out by people looking to make a one-off essential
                purchase. Unlike with a{' '}
                <a
                    href="https://www.totallymoney.com/loans/secured/"
                    target="_blank"
                >
                    secured loan
                </a>{' '}
                lenders won’t require you to secure the loan against your
                property as personal loans are usually for smaller amounts.
                However this doesn’t mean they are without risk, and your credit
                rating may determine the size of the loan you will be able to
                take out.
            </Text>
            <Text>
                There are literally 100s of personal loans, which are sometimes
                known as unsecured loans, to choose from, and while they can be
                a solid option when looking for small amounts of money, the
                sheer number of personal loans available to you can make it hard
                to find the right deal.
            </Text>
            <Text>
                Here we look at the benefits and disadvantages of personal
                loans, and show you the other options available to you.
            </Text>

            <Heading variant="60" as="h2">
                Pros and cons of personal loans
            </Heading>

            <Text>
                Personal loans have many uses - be it a holiday, home
                improvement or a wedding. However they can also help you
                organise your finances by being used to pay off existing debts
                so you only have to make one repayment each month. This might
                not be the most cost-efficient way of simplifying your finances,
                however it can reduce the chances that you will miss a payment
                each month.
            </Text>
            <Text>
                A cheap personal loan can also sometimes allow you to borrow
                more than you might be able to with a credit card. Interest
                rates on personal loans are often fixed (but not always, so make
                sure you check before applying for one), giving you the chance
                to put a plan in place to ensure you don’t fall behind on
                repayments.
            </Text>
            <Text>
                Of course personal loan interest rates can often be quite high
                compared to secured loans. Be sure to check the details of the
                loan before you apply for it as well. Obviously this applies to
                any type of loan, but personal loans sometimes have early
                repayment charges, which are not ideal if you find yourself in a
                position to pay off your debt entirely.
            </Text>
            <Text>
                A bad credit rating can also impact the amount you are able to
                borrow, so be aware that lenders will look at this when
                considering giving you a loan.
            </Text>

            <Heading variant="60" as="h2">
                Alternatives to a personal loan{' '}
            </Heading>

            <Text>
                Before applying for any loan you need to consider exactly what
                you need need the money for and then take the time to look into
                other options available to you.
            </Text>
            <Text>
                Are you hoping to buy a car? In this case you should definitely
                look into{' '}
                <a
                    href="https://www.totallymoney.com/loans/car-finance/"
                    target="_blank"
                >
                    car finance loans
                </a>
                .
            </Text>
            <Text>
                Personal loans are sometimes used in order to pay off multiple
                debtors to simplify finances, however if this is your plan then
                a{' '}
                <a
                    href="https://www.totallymoney.com/loans/debt-consolidation/"
                    target="_blank"
                >
                    debt consolidation loan{' '}
                </a>{' '}
                could help you.
            </Text>
            <Text>
                Remember, a personal loan isn’t the only way to borrow small
                amounts of money. If you are looking to borrow £3,000 or less a{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/purchase/"
                    target="_blank"
                >
                    credit card
                </a>{' '}
                might actually offer a better interest rate than a personal
                loan. The longest 0% purchase card offer is 27 months, which
                means if you are going to borrow less than £3,000 and are
                confident that you can repay the full amount within 27 months
                then this might be a good option for you.{' '}
            </Text>

            <Heading variant="60" as="h2">
                Things to remember
            </Heading>
            <Text>
                The amount of money you are able to borrow with a personal loan
                will be limited if you have a bad credit rating. If this makes
                you nervous then don’t worry, there are other ways you can
                borrow money.
            </Text>
            <Text>
                <a
                    href="https://www.totallymoney.com/credit-cards/credit-cards-bad-credit/"
                    target="_blank"
                >
                    Cards for people with poor credit
                </a>{' '}
                are, as the name suggests, perfect for people in this situation.
                Using our comparison tool you can find which of these cards you
                are most likely to be accepted by.
            </Text>
            <Text>
                As we have already said, people often consider personal loans a
                risk-free option when compared to secured loans because they are
                not taken out against your house. While they might appear less
                risky, if you take out a personal loan and fall behind on your
                repayments then you can be taken to court and received a County
                Court Judgement (CCJ). This seriously damages your credit
                rating, making it very hard to find credit cards or cheap
                personal loans that will accept you in the future.
            </Text>
            <Text>
                When taking out a loan or getting a credit card it is important
                that you have a budget plan in place to ensure that you are able
                to make the repayments each month. You should also know the
                length of time it will take you to repay the money back in full,
                as the longer it takes the more interest you will be paying,
                making the loan more expensive.
            </Text>
        </>
    )
}

export default ContentPersonal
